import {ironCondor, IronCondor} from "./iron-condor/IronCondorIdeaPayoffComponent";

export default function(parentDir: string): string {
    const rootDir = `${parentDir}/charts`;

    return angular.module("tfApp.trading-ideas.elements.payoff.charts", [])
                  .component(IronCondor, ironCondor(rootDir))
                  .name;
}
